/*import { Product } from "../types/product";
import ProductCard from "./ProductCard";
import ProductSkeleton from "./ProductSkeleton";

interface Props {
  products: Product[];
  loading: boolean;
}

export default function ProductGrid({ products, loading }: Props) {
  if (loading) {
    return (
      <div className="row g-4">
        {[...Array(8)].map((_, i) => (
          <div className="col-6 col-md-4 col-lg-3" key={i}>
            <ProductSkeleton />
          </div>
        ))}
      </div>
    );
  }

  if (!products.length) {
    return <p className="text-center text-muted">No products found</p>;
  }

  return (
    <div className="row g-4">
      {products.map((p) => (
        <div className="col-6 col-md-4 col-lg-3" key={p.id}>
          <ProductCard product={p} />
        </div>
      ))}
    </div>
  );
}
*/
// src/components/ProductGrid.tsx
/*
import { Product } from "../types/product";
import { SaleItem } from "../types/sale";

interface Props {
  products: Product[];
  loading: boolean;
  onBuy: (item: SaleItem) => void;
  onSort?: (field: string) => void; // ✅ new optional prop
}

export default function ProductGrid({ products, loading, onBuy, onSort }: Props) {
  if (loading) {
    return (
      <div className="d-flex align-items-center mt-3">
        <div className="spinner-border text-primary me-2" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <span className="text-info">Loading products…</span>
      </div>
    );
  }

  if (!loading && products.length === 0) {
    return <p className="text-muted">No products found</p>;
  }

  return (
    <table className="table table-hover">
      <thead>
        <tr>
          <th
            style={{ cursor: onSort ? "pointer" : "default" }}
            onClick={() => onSort && onSort("name")}
          >
            Name
          </th>
          <th
            style={{ cursor: onSort ? "pointer" : "default" }}
            onClick={() => onSort && onSort("brand")}
          >
            Brand
          </th>
          <th
            style={{ cursor: onSort ? "pointer" : "default" }}
            onClick={() => onSort && onSort("price")}
          >
            Price
          </th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {products.map((p) => (
          <tr key={p.id}>
            <td>{p.name}</td>
            <td>{p.brand}</td>
            <td>{p.price} ETB</td>
            <td>
              <button
                className="btn btn-primary btn-sm"
                onClick={() =>
                  onBuy({
                    product_id: p.id,
                    name: p.name,
                    price: p.price,
                    quantity: 1,
                  })
                }
              >
                Add
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

*/

// src/components/ProductGrid.tsx
// src/components/ProductGrid.tsx
// src/components/ProductGrid.tsx
// src/components/ProductGrid.tsx
import ProductCard from "./ProductCard";
import ProductSkeleton from "./ProductSkeleton";
import { Product } from "../types/product";
import { SaleItem } from "../types/sale";

interface Props {
  products: Product[];
  loading: boolean;
  onBuy: (item: SaleItem) => void;
  sortField: string;
  sortOrder: "asc" | "desc";
  onSort: (field: string) => void;
  onQuickView: (product: Product) => void; // ✅ new
}

export default function ProductGrid({ products, loading, onBuy, sortField, sortOrder, onSort, onQuickView }: Props) {
  if (loading) {
    return (
      <div className="row g-4">
        {[...Array(8)].map((_, i) => (
          <div className="col-6 col-md-4 col-lg-3" key={i}>
            <ProductSkeleton />
          </div>
        ))}
      </div>
    );
  }

  if (!products.length) {
    return <p className="text-center text-muted">No products found</p>;
  }

  return (
    <>
      {/* Sort bar */}
      <div className="d-flex justify-content-end mb-3">
        <div className="btn-group">
          <button className="btn btn-outline-secondary btn-sm" onClick={() => onSort("name")}>
            Name {sortField === "name" ? (sortOrder === "asc" ? "▲" : "▼") : ""}
          </button>
          <button className="btn btn-outline-secondary btn-sm" onClick={() => onSort("brand")}>
            Brand {sortField === "brand" ? (sortOrder === "asc" ? "▲" : "▼") : ""}
          </button>
          <button className="btn btn-outline-secondary btn-sm" onClick={() => onSort("price")}>
            Price {sortField === "price" ? (sortOrder === "asc" ? "▲" : "▼") : ""}
          </button>
        </div>
      </div>

      {/* Product cards */}
      <div className="row g-4">
        {products.map((p) => (
          <div className="col-6 col-md-4 col-lg-3" key={p.id}>
            <ProductCard product={p} onBuy={onBuy} onQuickView={onQuickView} />
          </div>
        ))}
      </div>
    </>
  );
}

